import type { ChartStyleSettings } from "../../../../../../../../../api/types/svTypes.ts";
import { useAppDispatch } from "../../../../../store/hooks/useAppDispatch.ts";
import { fieldsStateActions } from "../../../../../store/thunks/fieldStatesThunks.ts";
import SwitchField from "../../../../common/SwitchField.tsx";
import { isLinearSettings } from "../../../../viewer/chart/helper.ts";
import { isRotated } from "../../../../viewer/chart/isRotated.ts";

interface Props {
  settings: ChartStyleSettings;
  readonlyMode: boolean;
}

export default function RotateItem({ settings, readonlyMode }: Props) {
  const dispatch = useAppDispatch();
  const supported = isLinearSettings(settings);
  const rotated = isRotated(settings);

  if (!supported) {
    return <></>;
  }

  return (
    <SwitchField
      label="Rotated"
      checked={rotated}
      disabled={readonlyMode}
      onChange={(newValue) => dispatch(fieldsStateActions.updateSettings({ settings: { rotated: newValue } }))}
      tooltipText="Swaps the axes around making the value axis horizontal and the argument axis vertical"
      typographyProps={{ sx: { color: "text.secondary" } }}
    />
  );
}
